import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SiteLayout from "../components/SiteLayout";
import { SERVICES } from "../data/staticData";
import CTASection from "../components/sections/CTASection";

export default function Services() {
  return (
    <SiteLayout>
      <section className="pt-20 pb-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="eyebrow mb-4">All services</div>
          <h1 className="font-display text-5xl sm:text-6xl font-bold tracking-tight max-w-3xl">
            Productized SEO & Digital PR — built to scale your output.
          </h1>
          <p className="mt-6 text-inkSoft text-lg max-w-2xl">
            Browse the full catalog — link building, guest posting, digital PR, local SEO and technical work. Every service is fixed-scope, fixed-priced and white-label-ready.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="card-soft p-7 group"
                data-testid={`services-list-${s.slug}`}
              >
                <div className="h-12 w-12 rounded-xl bg-surfaceAlt grid place-items-center text-terra group-hover:bg-terra group-hover:text-white transition">
                  <Icon size={22} />
                </div>
                <h2 className="font-display text-2xl font-semibold tracking-tight mt-5">{s.title}</h2>
                <p className="mt-3 text-sm text-inkSoft leading-relaxed">{s.short}</p>
                <div className="mt-6 pt-5 border-t border-line flex items-center justify-between">
                  <span className="text-xs text-inkSoft">From <span className="font-mono font-semibold text-ink">${s.starting_price}</span></span>
                  <ArrowUpRight size={18} className="text-inkSoft group-hover:text-terra" />
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      <CTASection />
    </SiteLayout>
  );
}
